import { Button, Flex, Link, Text, Img } from "@chakra-ui/react";
import Router from "next/router";

export function MenuDisconnected({ onClose }: { onClose: () => void }) {
  return (
    <Flex justify="space-around" alignItems="center">
      <Flex direction="column" padding="15px" w="100%">
        <Link
          textTransform="uppercase"
          _hover={{ textDecoration: "none" }}
          onClick={() => {
            onClose();
            Router.push("/login");
          }}
        >
          <Button w={"full"} variant={"primary-button"} mb={"15px"} _hover={{ opacity: "0.5" }}>
            ACESSE SUA CONTA
          </Button>
        </Link>
        <Link
          textTransform="uppercase"
          _hover={{ textDecoration: "none" }}
          onClick={() => {
            onClose();
            Router.push("/cadastro");
          }}
        >
          <Button w={"full"} variant={"secondary-button"} _hover={{ opacity: "0.5" }}>
            CRIE SUA CONTA
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
}
